import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, finalize, tap } from 'rxjs';

import { AuthenticationService } from '../services/auth.service';
import { AuthfakeauthenticationService } from '../services/authfake.service';
import { environment } from '../../../environments/environment';
import { ApiLoaderService } from '../services/api-loader.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private authfackservice: AuthfakeauthenticationService,
        private loaderService: ApiLoaderService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (localStorage.getItem('token')) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
        }

        // Show loader before sending the request
        this.loaderService.show();

        return next.handle(request).pipe(
            tap({
                next: (event) => {
                    if (event instanceof HttpResponse) {
                        // Hide loader on successful response
                        this.loaderService.hide();
                    }
                },
                error: (error: HttpErrorResponse) => {
                    // Hide loader on error response
                    this.loaderService.hide();
                }
            }),
            finalize(() => {
                // Ensure loader is hidden in all cases
                this.loaderService.hide();
            })
        );
    }
}
